import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./components/Login/Login";
import Dashboard from "./components/AccessManagement/Dashboard";
import ProtectedRoute from "./protectedLayout";

import ListOfUsers from "./components/ListOfUsers/ListOfUsers";
import Home from "./components/home/Home";
import NotAuthorised from "./NotAuthorised";
import Projects from "./components/Projects/Projects";
import RolesPermissions from "./components/RolesPermissions/RolesPermissions";
import AuditLogs from "./components/AuditLogs/AuditLogs";
import OrganizationHierarchyPage from "./components/OrganizationHierarchy/OrganizationHierarchyPage";
import Attendance from "./components/Attendance/Attendance";
import DocumentsPage from "./components/Documents/DocumentsPage";
// import EmailTemplates from "./components/EmailTemplates/EmailTemplates";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route path="/" element={<ProtectedRoute />}>
          <Route path="/dashboard/access-management" element={<Dashboard />} />
          <Route path="/dashboard/home" element={<Home />} />
          <Route path="/dashboard/users-list" element={<ListOfUsers />} />
          <Route
            path="/dashboard/org-hierarchy"
            element={<OrganizationHierarchyPage />}
          />
          <Route path="/dashboard/projects" element={<Projects />} />
          <Route path="/dashboard/roles" element={<RolesPermissions />} />
          {/* <Route path="/dashboard/email-templates" element={<EmailTemplates />} /> */}
          <Route path="/dashboard/audit-logs" element={<AuditLogs />} />
          <Route path="/dashboard/attendance" element={<Attendance />} />
          <Route path="/dashboard/documents" element={<DocumentsPage />} />
        </Route>

        <Route path="*" element={<NotAuthorised />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
